// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"1b24af0d","179":"9da8517c","207":"438f07f0","330":"a50ba2b8","594":"b9c56789"}[chunkId] + ".js";
};